import * as React from 'react';

import { Button } from 'react-bootstrap';

import {View} from './libs/WebComponents';
import {validateToken, wpAuthGET} from './api/api-user';
import {useUserStore} from './store/user';
import { useGrowlStore } from './store/growls';
import { usePopupStore } from './store/popups';

import type {HandleFetchError} from './api/api-root';
import Pager from './Pages/Pager';
import Popup, {Dialog} from './Popup';
import { Props } from './types/types';
import { do_actions } from './utils/FiltersAndActions';
import { useQuestionStore } from './store/questions';
import GoogleMap from './Components/GoogleMap';
import {APP_VERSION} from './Constants';
export type GeoLocation = {lat: number, lng: number, zoom: number};

export type WpPage = {
   ID: number
   featured_img: string
   page_type: string
   post_content: string
   post_excerpt: string
   post_name: string
   post_title: string
   protected: boolean
   question_type?: string
   image1?: string
   geolocation?: GeoLocation

};

export type ParsePage = {
   page: WpPage
   props: Props
}

export type VisitorRoleType = {
   label: string
   value: string
}

export type GroupType = {
   ID: number
   title: string
   description: string
   geolocation?: GeoLocation
   featured_img: null | string
   visitor_roles: VisitorRoleType[]
};


let init = false;
const root = window.location.href.split('#')[0];
const App = () => {


   const [index, setIndex] = React.useState(0);
   const [group, setGroup] = React.useState<GroupType>({ID:0, title:'', description:'',geolocation: undefined, featured_img: null, visitor_roles: []});
   const [pages, setPages] = React.useState<ParsePage[]>([]);
   const {firstname, token, group_id, updateToken, removeUser} = useUserStore();
   const {removeQuestions} = useQuestionStore();
   const [chaptersStart, setChaptersStart] = React.useState(0);
   const [chapterPagesLength, setChapterPagesLength] = React.useState(0);

   const { addGrowl } = useGrowlStore();
   const { addPopup, removePopup } = usePopupStore();

   const nextPage = React.useCallback(()=>{
      do_actions('submitAnswers');
      setIndex(i=>{
         i=i+1;
         if (i>=pages.length-1){
            i=pages.length-1;
         }
         if (pages[i]) window.history.pushState(null, "", root + '#' + pages[i].page.post_name);
         return i;
      });
   },[pages, index]);

   const prevPage = React.useCallback(()=>{
      setIndex(i=>{
         i=i-1;
         if (pages[i] && pages[i].page.post_name === 'app-signup') i=i-1;
         if (i<=0){
            i=0;
         };
         if (pages[i]) window.history.pushState(null, "", root + '#' + pages[i].page.post_name);
         return i;
      });
   },[pages, index]);

   const goTo = React.useCallback((i: number)=>{
      setIndex(i);
      if (pages[i]) window.history.pushState(null, "", root + '#' + pages[i].page.post_name);
   },[pages, index]);


   const loadAllPages = React.useCallback(async()=>{
   for(const p of ['startpages', 'chapters', 'endpages']){
         await loadPages(p);
      }
      loadGroupData();
      window.scrollTo(0,10);
   },[]);

   const loadGroupData = React.useCallback(async()=>{
      try{
         const results: GroupType = await wpAuthGET('group/'+group_id);
         setGroup(results);
      }catch(err: HandleFetchError | any)
      {
         console.log(err);
         addGrowl({type:'danger', message:'API call: '+String(err.error.message), dismissible:true});
         console.warn(err.error);
      }
   },[]);
   const loadPages = React.useCallback(async(setname: string)=>{
      try{
         const results: WpPage[] = await wpAuthGET('pages', {setname:setname, group_id});
         parsePages(results, setname);
      }catch(err: HandleFetchError | any)
      {
         console.log(err);
         addGrowl({type:'danger', message:'API call: '+String(err.error.message), dismissible:true});
         console.warn(err.error);
      }
   },[]);

   const parsePages = React.useCallback((results: WpPage[], setname: string)=>{
      const new_pages: ParsePage[]= [];
      let chapter = 0;
      results.map((page, i: number)=>{
         if (Array.isArray(page) && setname ==='chapters')
         {
            chapter++;
            page.map((p: WpPage, ii: number)=>{
               new_pages.push({page: p, props: {chapter: Number(chapter), main_chapter:ii===0, index:ii, firstname, goTo, prevPage, nextPage}});
            });
            setChapterPagesLength(new_pages.length);
         }else{
            new_pages.push({page, props: {index:i, firstname, goTo, prevPage, nextPage}});
         }
         return new_pages;
      });
      if(setname === 'startpages'){
         setChaptersStart(new_pages.length);
      }
      setPages( ps => [...ps, ...new_pages]);
   },[]);


   const _restartRequest = ()=>{
      const uuid = addPopup({type:'dialog', dismissible:false, children:(
         <Dialog title="Weet je het zeker?">
            <Button onClick={()=>{
            _restart();
            removePopup(uuid);
         }}>Start opnieuw</Button>
         </Dialog>
      )});
   }

   const _restart = ()=>{
      removeUser();
      removeQuestions();
      _gotoStart();
   }

   const _gotoStart = ()=>{
      goTo(0);
   };

   const _openLocationPopup = (geolocation?: GeoLocation)=>{
      const uuid = addPopup({type:'googlemap', dismissible:false, children:(
         <GoogleMap geolocation={geolocation} closePopup={()=>removePopup(uuid)} />
      )});
   }




   React.useEffect(() => {

      if (group_id > 0 && globalThis.group_id !== group_id){
         removeUser();
         setTimeout(()=>{
            window.location.reload();
         },500);
      }

      if (!init) {
         init = true;
         console.log('APP VERSION: ' + APP_VERSION);
         loadAllPages();
      }

      // connecting raw_html functions to globalThis
      globalThis.Pager_goTo = goTo;
      if (token){
         validateToken().then((res: {valid: boolean})=>{
            if (!res || !res.valid)
            {
               updateToken('');
            }
            _gotoStart();
         });
      }else{
         _gotoStart();
      }
      window.addEventListener("popstate", handleEvent);
      window.addEventListener('nav::user_asked_history', ()=>{});
     
      return () => {
         window.removeEventListener("popstate", handleEvent);
         window.removeEventListener("nav::user_asked_history", ()=>{});
      }

   }, []);

   const handleEvent = (e: any) => {
      prevPage();
   }

  
   return (
      <View className="view App">
         {pages.length>0?(
         <Pager
            token={token}
            pages={pages}
            index={index}
            group={group}
            goTo={goTo}
            nextPage={nextPage}
            prevPage={prevPage}
            chapters_start={chaptersStart}
            chapter_pages_length={chapterPagesLength}
            restart={_restartRequest}
            openLocationPopup={_openLocationPopup}
         />):null}
         <Popup />
      </View>
   );
};

export default React.memo(App);
